module.exports = __webpack_public_path__ + "static/img/6.0f741e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/6.jpg
// module id = FOb3
// module chunks = 0